module.exports = __webpack_public_path__ + "static/media/pigeon-eating-saag.0b60957e.png";